import {
    FETCH_NOTIFICATIONS,
    FETCH_NOTIFICATIONS_SUMMARY,
    MARK_ALL_READ_NOTIFICATIONS,
    MARK_READ_NOTIFICATIONS,
    MARK_NOTIFICATION_UNREAD
} from '../actions/types';

const INIT_STATE = {
    list: {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
        unread_count: 0
    },
    summary: {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
        unread_count: 0
    }
};

export default function notificationsReducer(state = INIT_STATE, action) {
    switch (action.type) {

        // Danh sách đầy đủ (Notification List Page)
        case FETCH_NOTIFICATIONS: {
            const { items, pagination, unreadCount } = action.payload;

            return {
                ...state,
                list: {
                    ...state.list,
                    data: items,
                    pagination,
                    unread_count: unreadCount
                }
            };
        }

        // Danh sách tóm tắt (Header/Popover)
        case FETCH_NOTIFICATIONS_SUMMARY: {
            const { items, pagination, unreadCount } = action.payload;

            let merged = pagination.currentPage > 1
                ? [...state.summary.data, ...items]
                : [...items];

            merged = merged.filter(
                (v, i, a) => a.findIndex(v2 => v2.id === v.id) === i
            );
            merged.sort((a, b) => b.id - a.id);

            //console.log('merged', merged);
            return {
                ...state,
                summary: {
                    ...state.summary,
                    data: merged,
                    pagination,
                    unread_count: unreadCount
                }
            };
        }

        // Đánh dấu đã đọc 1 thông báo
        case MARK_READ_NOTIFICATIONS: {
            const id = action.payload;

            const markOne = (list) =>
                list.map(n =>
                    n.id === id
                        ? { ...n, read_at: n.read_at || new Date().toISOString() }
                        : n
                );

            return {
                ...state,
                list: {
                    ...state.list,
                    data: markOne(state.list.data),
                    unread_count: Math.max(0, state.list.unread_count - 1)
                },
                summary: {
                    ...state.summary,
                    data: markOne(state.summary.data),
                    unread_count: Math.max(0, state.summary.unread_count - 1)
                }
            };
        }

        // Đánh dấu tất cả đã đọc
        case MARK_ALL_READ_NOTIFICATIONS: {
            const markAll = (list) =>
                list.map(n => ({
                    ...n,
                    read_at: n.read_at || new Date().toISOString(),
                }));

            return {
                ...state,
                list: {
                    ...state.list,
                    data: markAll(state.list.data),
                    unread_count: 0
                },
                summary: {
                    ...state.summary,
                    data: markAll(state.summary.data),
                    unread_count: 0
                }
            };
        }

        case MARK_NOTIFICATION_UNREAD: {
            const updateList = (list) =>
                list.map(n => n.id === action.payload.id ? { ...n, read_at: null } : n);

            return {
                ...state,
                list: { ...state.list, data: updateList(state.list.data), unread_count: state.list.unread_count + 1 },
                summary: { ...state.summary, data: updateList(state.summary.data), unread_count: state.summary.unread_count + 1 }
            };
        }

        default:
            return state;
    }
}
